/**
 * REAKTICE BRAND COLORS
 * Palette colori centralizzata per tutto il progetto
 * 
 * Reaktice S.r.l.s. - Firenze, Italy
 * https://www.reaktice.com
 */

const reakticeColors = {
  // ========================================
  // PRIMARY COLORS - Reaktice Brand
  // ========================================
  primary: '#0287B3',           // Reaktice Primary Blue (main brand color)
  primaryDark: '#016A8F',       // Darker shade for depth
  primaryLight: '#33A3C7',      // Lighter shade for hover/contrast
  
  // ========================================
  // SECONDARY COLORS
  // ========================================
  secondary: '#FF6F00',         // Accent Orange (energy, CTA buttons)
  secondaryDark: '#E65100',     // Orange hover state
  secondaryLight: '#FF8F00',    // Light orange
  
  // ========================================
  // GRADIENTS
  // ========================================
  gradient: {
    primary: 'linear-gradient(135deg, #016A8F 0%, #0287B3 50%, #33A3C7 100%)',
    hero: 'linear-gradient(135deg, #016A8F 0%, #0287B3 50%, #33A3C7 100%)',
    card: 'linear-gradient(135deg, #0287B3 0%, #33A3C7 100%)',
    dark: 'linear-gradient(135deg, #016A8F 0%, #024D6B 100%)',
  },
  
  // ========================================
  // PRICING PLANS COLORS
  // ========================================
  plans: {
    basic: '#33A3C7',           // Light blue
    premium: '#0287B3',         // Primary (popular)
    premiumPlus: '#016A8F',     // Dark blue
  },
  
  // ========================================
  // NEUTRAL COLORS
  // ========================================
  background: '#FAFAFA',        // Light background
  surface: '#FFFFFF',           // White surface
  
  text: {
    primary: '#1a1a1a',         // Primary text (dark)
    secondary: '#333333',       // Secondary text
    tertiary: '#666666',        // Tertiary text
    disabled: '#9e9e9e',        // Disabled text
    inverse: '#FFFFFF',         // White text on dark backgrounds
  },
  
  // ========================================
  // FEEDBACK COLORS
  // ========================================
  success: '#4CAF50',           // Green - Success states
  warning: '#FFA726',           // Orange - Warning states
  error: '#f44336',             // Red - Error states, close icons
  info: '#0287B3',              // Primary blue - Info states
  
  // ========================================
  // BORDERS & DIVIDERS
  // ========================================
  border: {
    light: 'rgba(0, 0, 0, 0.1)',
    medium: 'rgba(0, 0, 0, 0.2)',
    dark: 'rgba(0, 0, 0, 0.3)',
    white: 'rgba(255, 255, 255, 0.3)',
  },
  
  // ========================================
  // OVERLAYS & GLASSMORPHISM
  // ========================================
  overlay: {
    light: 'rgba(255, 255, 255, 0.15)',
    medium: 'rgba(255, 255, 255, 0.25)',
    dark: 'rgba(0, 0, 0, 0.5)',
    card: 'rgba(255, 255, 255, 0.95)',
  },
  
  // ========================================
  // SHADOWS
  // ========================================
  shadow: {
    text: '2px 2px 4px rgba(0,0,0,0.3)',
    textLight: '1px 1px 2px rgba(0,0,0,0.3)',
    card: '0 4px 6px rgba(0,0,0,0.1)',
    elevated: '0 8px 16px rgba(0,0,0,0.15)',
  },
};

// ========================================
// ALTERNATIVE THEMES
// ========================================

/**
 * SOULTECH THEME
 * Palette basata sulla landing page https://www.soul-teck.com/landing/
 * Design moderno con sfondo chiaro, teal vibrante e accenti caldi
 */
const soulTechColors = {
  // ========================================
  // PRIMARY COLORS - SoulTech Landing Theme
  // ========================================
  primary: '#2A9D8F',           // Teal vibrante (colore principale dalla landing)
  primaryDark: '#1F7A6F',       // Teal scuro per depth
  primaryLight: '#3DB9AA',      // Teal chiaro per hover/contrast
  
  // ========================================
  // SECONDARY COLORS
  // ========================================
  secondary: '#E9C46A',         // Oro/Giallo caldo (accento luminoso)
  secondaryDark: '#D4A84A',     // Oro scuro
  secondaryLight: '#F4D68A',    // Oro chiaro
  
  // ========================================
  // ACCENT COLORS
  // ========================================
  accent: '#F4A261',            // Arancione pesca (CTA, evidenziazioni)
  accentDark: '#E07B3D',        // Arancione scuro
  accentLight: '#FFB77F',       // Arancione chiaro
  
  // ========================================
  // LIGHT BACKGROUND (sfondo chiaro)
  // ========================================
  dark: '#264653',              // Blu petrolio scuro (per header/footer)
  darkLight: '#2A4F5F',         // Petrolio medio
  darkDark: '#1A323B',          // Petrolio profondo
  
  // ========================================
  // GRADIENTS
  // ========================================
  gradient: {
    primary: 'linear-gradient(135deg, #1F7A6F 0%, #2A9D8F 50%, #3DB9AA 100%)',
    hero: 'linear-gradient(135deg, #F8FAFB 0%, #EDF4F5 50%, #E0EEEF 100%)',
    card: 'linear-gradient(135deg, rgba(42, 157, 143, 0.05) 0%, rgba(233, 196, 106, 0.05) 100%)',
    teal: 'linear-gradient(135deg, #2A9D8F 0%, #3DB9AA 100%)',
    dark: 'linear-gradient(180deg, #264653 0%, #1A323B 100%)',
    glass: 'linear-gradient(135deg, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0.7) 100%)',
  },
  
  // ========================================
  // PRICING PLANS COLORS
  // ========================================
  plans: {
    basic: '#3DB9AA',           // Teal chiaro
    premium: '#2A9D8F',         // Teal principale (popular)
    premiumPlus: '#264653',     // Blu petrolio
  },
  
  // ========================================
  // NEUTRAL COLORS (LIGHT THEME)
  // ========================================
  background: '#F8FAFB',        // Bianco leggermente grigio/azzurro
  surface: '#FFFFFF',           // Bianco puro per card
  surfaceLight: '#EDF4F5',      // Grigio azzurro chiaro
  
  text: {
    primary: '#264653',         // Blu petrolio scuro
    secondary: '#4A6572',       // Grigio blu
    tertiary: '#6B8A97',        // Grigio medio
    disabled: '#9DB5BE',        // Grigio chiaro
    inverse: '#FFFFFF',         // Bianco su sfondi scuri
    accent: '#2A9D8F',          // Teal per link/accent
  },
  
  // ========================================
  // FEEDBACK COLORS
  // ========================================
  success: '#10B981',           // Verde emeraldo
  warning: '#F59E0B',           // Ambra
  error: '#EF4444',             // Rosso vivace
  info: '#2A9D8F',              // Teal - Info states
  
  // ========================================
  // BORDERS & DIVIDERS
  // ========================================
  border: {
    light: 'rgba(38, 70, 83, 0.08)',
    medium: 'rgba(38, 70, 83, 0.15)',
    dark: 'rgba(38, 70, 83, 0.25)',
    teal: 'rgba(42, 157, 143, 0.3)',
  },
  
  // ========================================
  // OVERLAYS & GLASSMORPHISM
  // ========================================
  overlay: {
    light: 'rgba(255, 255, 255, 0.8)',
    medium: 'rgba(255, 255, 255, 0.9)',
    dark: 'rgba(38, 70, 83, 0.7)',
    card: 'rgba(255, 255, 255, 0.95)',
    glass: 'rgba(255, 255, 255, 0.85)',
  },
  
  // ========================================
  // SHADOWS
  // ========================================
  shadow: {
    text: '1px 1px 2px rgba(38, 70, 83, 0.1)',
    textLight: '0 1px 1px rgba(38, 70, 83, 0.05)',
    card: '0 4px 12px rgba(38, 70, 83, 0.08)',
    elevated: '0 8px 24px rgba(38, 70, 83, 0.12)',
    glow: '0 0 20px rgba(42, 157, 143, 0.2)',
  },
};

// ========================================
// HELPER FUNCTIONS
// ========================================

/**
 * Get rgba version of primary color with custom opacity
 * @param {number} opacity - Opacity value between 0 and 1
 * @returns {string} rgba color string
 */
export const getPrimaryWithOpacity = (opacity = 0.1) => {
  // Convert #0287B3 to rgba
  return `rgba(2, 135, 179, ${opacity})`;
};

/**
 * Get rgba version of secondary color with custom opacity
 * @param {number} opacity - Opacity value between 0 and 1
 * @returns {string} rgba color string
 */
export const getSecondaryWithOpacity = (opacity = 0.1) => {
  // Convert #FF6F00 to rgba
  return `rgba(255, 111, 0, ${opacity})`;
};

/**
 * Get color for plan based on plan name
 * @param {string} planName - Plan name (Basic, Premium, Premium Plus)
 * @returns {string} hex color
 */
export const getPlanColor = (planName) => {
  const planColors = {
    'Basic': reakticeColors.plans.basic,
    'Premium': reakticeColors.plans.premium,
    'Premium Plus': reakticeColors.plans.premiumPlus,
  };
  return planColors[planName] || reakticeColors.primary;
};

/**
 * Get SoulTech primary color with custom opacity
 * @param {number} opacity - Opacity value between 0 and 1
 * @returns {string} rgba color string
 */
export const getSoulTechPrimaryWithOpacity = (opacity = 0.1) => {
  // Convert #2A9D8F to rgba
  return `rgba(42, 157, 143, ${opacity})`;
};

/**
 * Get SoulTech secondary color with custom opacity
 * @param {number} opacity - Opacity value between 0 and 1
 * @returns {string} rgba color string
 */
export const getSoulTechSecondaryWithOpacity = (opacity = 0.1) => {
  // Convert #E9C46A to rgba
  return `rgba(233, 196, 106, ${opacity})`;
};

/**
 * Get SoulTech accent color with custom opacity
 * @param {number} opacity - Opacity value between 0 and 1
 * @returns {string} rgba color string
 */
export const getSoulTechAccentWithOpacity = (opacity = 0.1) => {
  // Convert #F4A261 to rgba
  return `rgba(244, 162, 97, ${opacity})`;
};

/**
 * Get SoulTech dark color with custom opacity
 * @param {number} opacity - Opacity value between 0 and 1
 * @returns {string} rgba color string
 */
export const getSoulTechDarkWithOpacity = (opacity = 0.1) => {
  // Convert #264653 to rgba
  return `rgba(38, 70, 83, ${opacity})`;
};

// ========================================
// FIXED BRAND COLORS (Non-theme dependent)
// ========================================

/**
 * Colori fissi per brand esterni o design specifici
 * Questi colori NON cambiano con il tema
 */
export const brandColors = {
  // WhatsApp brand colors
  whatsapp: {
    primary: '#25D366',      // WhatsApp green
    dark: '#128C7E',         // WhatsApp dark green
    light: '#25D36610',      // WhatsApp green con trasparenza
  },
  
  // Colori per pagine pubbliche (landing, login, registration) - Tema Default/Light
  light: {
    gradient: {
      primary: 'linear-gradient(135deg, #1a365d 0%, #2c5282 100%)',
      darkBg: '#2d3748',
    },
    primary: '#1976d2',
    secondary: '#2e7d32',
    text: {
      primary: '#333',
      secondary: '#666',
      light: '#999',
    },
    border: {
      light: '#ccc',
      medium: '#999',
      dark: '#666',
    },
    login: {
      heading: '#1a365d',
      subheading: '#2c5282',
      buttonBg: '#1976d2',
      buttonHover: '#1565c0',
      inputBg: '#f7fafc',
      inputBorder: '#e2e8f0',
      inputBorderHover: '#2c5282',
      inputBorderFocus: '#1976d2',
      inputText: '#1a202c',
      placeholder: '#a0aec0',
      checkboxColor: '#1976d2',
      rememberText: '#4a5568',
      captionText: '#666',
      circleDecor1: 'rgba(25, 118, 210, 0.1)',
      circleDecor2: 'rgba(25, 118, 210, 0.05)',
    },
  },
  
  // Colori per pagine pubbliche - Tema Dark
  dark: {
    gradient: {
      primary: 'linear-gradient(135deg, #0F1419 0%, #1A2129 50%, #232D38 100%)',
      darkBg: '#0A0E12',
    },
    primary: '#5B9BD5',
    secondary: '#4A90C2',
    text: {
      primary: '#E8ECF0',
      secondary: '#8899A6',
      light: '#5C6E7D',
    },
    border: {
      light: '#2D3843',
      medium: '#3D4A56',
      dark: '#4D5A66',
    },
    login: {
      heading: '#E8ECF0',
      subheading: '#5B9BD5',
      buttonBg: '#5B9BD5',
      buttonHover: '#4080C0',
      inputBg: '#1A2129',
      inputBorder: '#2D3843',
      inputBorderHover: '#5B9BD5',
      inputBorderFocus: '#5B9BD5',
      inputText: '#E8ECF0',
      placeholder: '#5C6E7D',
      checkboxColor: '#5B9BD5',
      rememberText: '#8899A6',
      captionText: '#8899A6',
      circleDecor1: 'rgba(91, 155, 213, 0.15)',
      circleDecor2: 'rgba(91, 155, 213, 0.08)',
    },
  },
  
  // Colori per pagine pubbliche - Tema Brown
  brown: {
    gradient: {
      primary: 'linear-gradient(135deg, #3E2723 0%, #5D4037 50%, #6D4C41 100%)',
      darkBg: '#2C1810',
    },
    primary: '#8D6E63',
    secondary: '#A1887F',
    text: {
      primary: '#EFEBE9',
      secondary: '#BCAAA4',
      light: '#8D6E63',
    },
    border: {
      light: '#4E342E',
      medium: '#5D4037',
      dark: '#6D4C41',
    },
    login: {
      heading: '#EFEBE9',
      subheading: '#D7CCC8',
      buttonBg: '#8D6E63',
      buttonHover: '#6D4C41',
      inputBg: '#3E2723',
      inputBorder: '#5D4037',
      inputBorderHover: '#8D6E63',
      inputBorderFocus: '#A1887F',
      inputText: '#EFEBE9',
      placeholder: '#8D6E63',
      checkboxColor: '#A1887F',
      rememberText: '#BCAAA4',
      captionText: '#BCAAA4',
      circleDecor1: 'rgba(141, 110, 99, 0.2)',
      circleDecor2: 'rgba(161, 136, 127, 0.1)',
    },
  },
  
  // Colori per pagine pubbliche - Tema SoulTech
  soultech: {
    gradient: {
      primary: 'linear-gradient(135deg, #1A323B 0%, #264653 50%, #2A4F5F 100%)',
      teal: 'linear-gradient(135deg, #1F7A6F 0%, #2A9D8F 50%, #3DB9AA 100%)',
      darkBg: '#1A323B',
    },
    primary: '#2A9D8F',
    secondary: '#E9C46A',
    text: {
      primary: '#264653',
      secondary: '#4A6572',
      light: '#8BA3B0',
    },
    border: {
      light: '#D1E0E4',
      medium: '#8BA3B0',
      dark: '#4A6572',
    },
    login: {
      heading: '#264653',
      subheading: '#2A9D8F',
      buttonBg: '#2A9D8F',
      buttonHover: '#1F7A6F',
      inputBg: '#F8FAFB',
      inputBorder: '#D1E0E4',
      inputBorderHover: '#2A9D8F',
      inputBorderFocus: '#2A9D8F',
      inputText: '#264653',
      placeholder: '#8BA3B0',
      checkboxColor: '#2A9D8F',
      rememberText: '#4A6572',
      captionText: '#4A6572',
      circleDecor1: 'rgba(42, 157, 143, 0.15)',
      circleDecor2: 'rgba(233, 196, 106, 0.1)',
    },
  },
  
  // Alias per retrocompatibilità
  public: null, // Verrà impostato dinamicamente
  
  // Colori per PDF e documenti stampabili
  print: {
    pink: '#FFDFF6',
    black: '#000',
    white: '#fff',
  },
};

// Imposta public come alias di light per retrocompatibilità
brandColors.public = brandColors.light;

// ========================================
// EXPORTS
// ========================================

export default reakticeColors;
export { soulTechColors };

// ========================================
// THEME COLORS - Tutti i temi dell'applicazione
// Centralizzati qui per gestione unica
// ========================================
export const themeColors = {
  // ========================================
  // DARK THEME - Blu caldi su sfondo scuro
  // Moderno, accogliente, alta leggibilità
  // ========================================
  dark: {
    primary: {
      main: '#5B9BD5',           // Blu caldo (tendente al ciano)
      light: '#7EB3E0',          // Blu chiaro caldo per hover
      dark: '#4080C0',           // Blu medio caldo per pressed
      contrastText: '#000000',   // Testo nero su pulsanti
    },
    secondary: {
      main: '#4A90C2',           // Blu acciaio caldo (sostituisce viola)
      light: '#6BA8D6',          // Blu chiaro
      dark: '#3578A8',           // Blu scuro
      contrastText: '#000000',
    },
    background: {
      default: '#0F1419',        // Nero blu caldo
      paper: '#1A2129',          // Grigio blu scuro per card
    },
    text: {
      primary: '#E8ECF0',        // Bianco caldo
      secondary: '#8899A6',      // Grigio blu per testi secondari
    },
    divider: 'rgba(255, 255, 255, 0.1)',
    action: {
      hover: 'rgba(91, 155, 213, 0.15)',
      selected: 'rgba(91, 155, 213, 0.25)',
      disabled: 'rgba(255, 255, 255, 0.3)',
    },
    error: { main: '#E57373', light: '#EF9A9A', dark: '#D32F2F' },
    warning: { main: '#FFB74D', light: '#FFCC80', dark: '#F57C00' },
    info: { main: '#5B9BD5', light: '#7EB3E0', dark: '#4080C0' },
    success: { main: '#81C784', light: '#A5D6A7', dark: '#388E3C' },
  },
  
  // ========================================
  // LIGHT THEME - Blu classico su sfondo chiaro
  // Professionale, pulito, corporate
  // ========================================
  light: {
    primary: {
      main: '#1565C0',           // Blu corporate
      light: '#1E88E5',          // Blu per hover
      dark: '#0D47A1',           // Blu scuro per pressed
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#7B1FA2',           // Viola profondo
      light: '#9C27B0',          // Viola per hover
      dark: '#6A1B9A',           // Viola scuro
      contrastText: '#ffffff',
    },
    background: {
      default: '#F8FAFC',        // Grigio azzurrino
      paper: '#FFFFFF',          // Bianco puro
    },
    text: {
      primary: '#1E293B',        // Grigio scuro blu
      secondary: '#64748B',      // Grigio medio
    },
    divider: 'rgba(0, 0, 0, 0.12)',
    action: {
      hover: 'rgba(21, 101, 192, 0.08)',
      selected: 'rgba(21, 101, 192, 0.15)',
      disabled: 'rgba(0, 0, 0, 0.26)',
    },
    error: { main: '#DC2626', light: '#EF4444', dark: '#B91C1C' },
    warning: { main: '#D97706', light: '#F59E0B', dark: '#B45309' },
    info: { main: '#0284C7', light: '#0EA5E9', dark: '#0369A1' },
    success: { main: '#16A34A', light: '#22C55E', dark: '#15803D' },
  },
  
  // ========================================
  // BROWN THEME - Toni caldi naturali
  // Accogliente, rilassante, elegante
  // ========================================
  brown: {
    primary: {
      main: '#8B5A2B',           // Marrone caldo
      light: '#A67B5B',          // Marrone chiaro
      dark: '#6B4423',           // Marrone scuro
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#B8860B',           // Oro antico
      light: '#DAA520',          // Oro chiaro
      dark: '#8B6914',           // Oro scuro
      contrastText: '#ffffff',
    },
    background: {
      default: '#FDF8F3',        // Crema caldo
      paper: '#FAF3EB',          // Beige chiaro
    },
    text: {
      primary: '#4A3728',        // Marrone scuro
      secondary: '#7D6454',      // Marrone medio
    },
    divider: '#D4C4B0',
    action: {
      hover: 'rgba(139, 90, 43, 0.1)',
      selected: 'rgba(139, 90, 43, 0.2)',
      disabled: '#C4B8A8',
    },
    error: { main: '#C53030', light: '#E53E3E', dark: '#9B2C2C' },
    warning: { main: '#C05621', light: '#DD6B20', dark: '#9C4221' },
    info: { main: '#2B6CB0', light: '#3182CE', dark: '#2C5282' },
    success: { main: '#2F855A', light: '#38A169', dark: '#276749' },
  },
  
  // ========================================
  // SOULTECH THEME - Basato su landing page soul-teck.com
  // Design moderno con sfondo chiaro, teal vibrante #2A9D8F
  // ========================================
  soultech: {
    primary: {
      main: soulTechColors.primary,        // #2A9D8F - Teal vibrante
      light: soulTechColors.primaryLight,  // #3DB9AA
      dark: soulTechColors.primaryDark,    // #1F7A6F
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: soulTechColors.secondary,       // #E9C46A - Oro caldo
      light: soulTechColors.secondaryLight, // #F4D68A
      dark: soulTechColors.secondaryDark,   // #D4A84A
      contrastText: '#264653',
    },
    background: {
      default: soulTechColors.background,   // #F8FAFB - Bianco azzurro
      paper: soulTechColors.surface,        // #FFFFFF - Bianco puro
      elevated: soulTechColors.surfaceLight, // #EDF4F5 - Grigio azzurro
    },
    text: {
      primary: soulTechColors.text.primary,   // #264653 - Blu petrolio
      secondary: soulTechColors.text.secondary, // #4A6572
    },
    divider: soulTechColors.border.light,
    action: {
      hover: 'rgba(42, 157, 143, 0.08)',
      selected: 'rgba(42, 157, 143, 0.15)',
      disabled: 'rgba(38, 70, 83, 0.26)',
    },
    error: { main: soulTechColors.error, light: '#F87171', dark: '#DC2626' },
    warning: { main: soulTechColors.warning, light: '#FBBF24', dark: '#D97706' },
    info: { main: soulTechColors.info, light: soulTechColors.primaryLight, dark: soulTechColors.primaryDark },
    success: { main: soulTechColors.success, light: '#34D399', dark: '#059669' },
    accent: {
      main: soulTechColors.accent,           // #F4A261 - Arancione pesca
      light: soulTechColors.accentLight,
      dark: soulTechColors.accentDark,
    },
  },
};

// Named exports per categorie - Reaktice Theme
export const { 
  primary, 
  primaryDark, 
  primaryLight, 
  secondary, 
  secondaryDark,
  secondaryLight 
} = reakticeColors;

export const { gradient } = reakticeColors;
export const { plans } = reakticeColors;
export const { text } = reakticeColors;
export const { success, warning, error, info } = reakticeColors;
